/**
 * Événement « une création en attente de réouverture (`?save=`) est prête et son
 * produit est DÉJÀ chargé » : la scène l'applique sans attendre un changement de
 * produit (qui n'aura pas lieu). Émis par App.vue, écouté par TresScene.
 */
export const APPLY_PENDING_DESIGN_EVENT = 'pxl:apply-pending-design';
